import {
    KNOWN_ADMIN_MODULES,
    migrateLegacyFeaturesToModules,
    normalizeModuleId,
} from "../config/adminModules";

export function buildDefaultFeaturePreferences() {
    return {
        mode: "full",
        enabledModules: [...KNOWN_ADMIN_MODULES],
    };
}

export const DEFAULT_FEATURE_PREFERENCES = buildDefaultFeaturePreferences();

export function parseFeaturePreferences(raw) {
    if (raw === undefined || raw === null) return buildDefaultFeaturePreferences();

    let value = raw;
    if (typeof value === "string") {
        try {
            value = JSON.parse(value);
        } catch {
            return buildDefaultFeaturePreferences();
        }
    }

    if (!value || typeof value !== "object" || Array.isArray(value)) {
        return buildDefaultFeaturePreferences();
    }

    const mode = value.mode === "admin-only" ? "admin-only" : "full";

    let enabledModules = [];
    if (Array.isArray(value.enabledModules)) {
        enabledModules = value.enabledModules
            .map((id) => normalizeModuleId(id))
            .filter(Boolean);
    } else if (Array.isArray(value.enabledFeatures)) {
        enabledModules = migrateLegacyFeaturesToModules(value.enabledFeatures);
    }

    return { mode, enabledModules };
}

export function serializeFeaturePreferences(raw) {
    const prefs = typeof raw?.mode === "string" ? raw : parseFeaturePreferences(raw);
    return `${prefs.mode}|${[...prefs.enabledModules].sort().join(",")}`;
}

export function sameFeaturePreferences(a, b) {
    return serializeFeaturePreferences(a) === serializeFeaturePreferences(b);
}

export function isModuleEnabledInPreferences(preferences, moduleId) {
    if (!moduleId) return true;
    if (preferences.mode === "full") return true;
    return preferences.enabledModules.includes(moduleId);
}

/** @deprecated Use isModuleEnabledInPreferences — kept for route guards. */
export function isFeatureEnabledInPreferences(preferences, featureOrModule) {
    return isModuleEnabledInPreferences(preferences, featureOrModule);
}
